const legalIcon = require('../assets/icons/legal.svg').default;
const accountIcon = require('../assets/icons/account.svg').default;
const historyIcon = require('../assets/icons/history.svg').default;
const paymentIcon = require('../assets/icons/payment.svg').default;
const infoIcon = require('../assets/icons/information.svg').default;
const dashboardIcon = require('../assets/icons/dashboard.svg').default;
const postJobIcon = require('../assets/icons/document-upload.svg').default;

export interface SidebarItem {
    title: string;
    icon: any;
    path: string;
};

export const ownerItems: SidebarItem[] = [
    {
        title: 'Dashboard',
        icon: dashboardIcon,
        path: '',
    },
    {
        title: 'Account',
        icon: accountIcon,
        path: 'account',
    },
    {
        title: 'Post Job',
        icon: postJobIcon,
        path: 'postjob',
    },
    {
        title: 'History',
        icon: historyIcon,
        path: 'history',
    },
    {
        title: 'Payment',
        icon: paymentIcon,
        path: 'payment',
    },
    {
        title: 'Legal',
        icon: legalIcon,
        path: 'legal'
    },
    {
        title: 'Support',
        icon: infoIcon,
        path: 'support'
    },
];

export const memberItems: SidebarItem[] = [
    {
        title: 'Dashboard',
        icon: dashboardIcon,
        path: '',
    },
    {
        title: 'Account',
        icon: accountIcon,
        path: 'account',
    },
    {
        title: 'Post Job',
        icon: postJobIcon,
        path: 'postjob',
    },
    {
        title: 'History',
        icon: historyIcon,
        path: 'history',
    },
    {
        title: 'Legal',
        icon: legalIcon,
        path: 'legal'
    },
    {
        title: 'Support',
        icon: infoIcon,
        path: 'support'
    },
];